var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 15.625H3.125V0.78125C3.125 0.349609 2.77539 0 2.34375 0H0.78125C0.349609 0 0 0.349609 0 0.78125V17.1875C0 18.0503 0.699707 18.75 1.5625 18.75H24.2188C24.6504 18.75 25 18.4004 25 17.9688V16.4062C25 15.9746 24.6504 15.625 24.2188 15.625ZM22.6562 1.5625H16.8916C15.8477 1.5625 15.3247 2.82471 16.063 3.56299L17.645 5.14502L14.0625 8.72803L10.48 5.14551C9.86963 4.53516 8.88037 4.53516 8.27051 5.14551L4.9165 8.49951C4.61133 8.80469 4.61133 9.29932 4.9165 9.60449L6.021 10.709C6.32617 11.0142 6.8208 11.0142 7.12598 10.709L9.375 8.45947L12.9575 12.042C13.5679 12.6523 14.5571 12.6523 15.167 12.042L19.8545 7.35449L21.4365 8.93652C22.1748 9.6748 23.437 9.15186 23.437 8.10791V2.34375C23.4375 1.91211 23.0879 1.5625 22.6562 1.5625Z",
    fill: "#5b93ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.c9d75e3ebeaa42f6f8205295bbc03dc1.svg";
export { ForwardRef as ReactComponent };